import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { peopleKeys } from './keys';
import type { CompanySearchResult, UserSearchResult } from '@/types/ticket';

// The API answers [] below two characters, so there is no point asking.
export const MIN_QUERY = 2;

// Staff-only type-ahead over all users; companyId narrows it to that company's members.
export function useUserSearch(q: string, companyId?: string) {
  const term = q.trim();
  return useQuery({
    queryKey: peopleKeys.users(term, companyId),
    queryFn: () => api<UserSearchResult[]>('/support-tickets/user-search', { query: companyId ? { q: term, companyId } : { q: term } }),
    enabled: term.length >= MIN_QUERY,
    placeholderData: keepPreviousData,
    staleTime: 30_000
  });
}

export function useCompanySearch(q: string) {
  const term = q.trim();
  return useQuery({
    queryKey: peopleKeys.companies(term),
    queryFn: () => api<CompanySearchResult[]>('/support-tickets/company-search', { query: { q: term } }),
    enabled: term.length >= MIN_QUERY,
    placeholderData: keepPreviousData,
    staleTime: 30_000
  });
}
